export default __webpack_public_path__ + "static/media/c3s.c6eec2e4.svg";